import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0730eaf2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "courseList" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
    key: 0,
    class: "infoItem wechatItem"
};
const _hoisted_4 = { class: "imgBox" };
const _hoisted_5 = { alt: "" };
const _hoisted_6 = {
    key: 0,
    class: "type font-24"
};
const _hoisted_7 = { class: "info flex-1 border-box" };
const _hoisted_8 = { class: "title text-ell2 font-32" };
const _hoisted_9 = {
    key: 0,
    class: "teacher text-overflow font-28"
};
const _hoisted_10 = { class: "expert gray-6" };
const _hoisted_11 = { class: "hospital gray-6" };
const _hoisted_12 = {
    key: 1,
    class: "studyInfo gray-6 font-24"
};
const _hoisted_13 = {
    key: 0,
    class: "date text-overflow"
};
const _hoisted_14 = {
    key: 1,
    class: "date text-overflow"
};
const _hoisted_15 = { key: 0 };
const _hoisted_16 = {
    key: 1,
    class: "time"
};
const _hoisted_17 = {
    key: 0,
    class: "m-l20"
};
import { appPort, jumpModuleApp, goToStudy, iOSPort } from '@/widget';
import { hostPath } from '@/public/utils/basePath';
import { useWxLaunchApp } from '@/hooks/appPage';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: {
            type: Array,
            default: () => []
        },
        process: {
            // 是否是练中的列表数据，显示学习进度
            default: false,
            type: Boolean
        },
        recommend: {
            // 是否是推荐的列表数据
            default: false,
            type: Boolean
        }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const fixedStatus = (item) => {
            if (/(OLD_OMO|NEW_OMO|TEAM|PERIOD)/.test(item.courseType)) {
                return false;
            }
            return true;
        };
        const adjustMin = (m) => {
            return Math.ceil(m / 60);
        };
        let isApp = appPort();
        // 进入详情
        const toDetail = (item) => {
            // (OLD_OMO|NEW_OMO|TEAM|PERIOD)/.test(item.courseType)
            if (showLaunch(item)) {
                return;
            }
            let { courseId, courseType } = item;
            if (isApp) {
                if (courseType == 'OLD_OMO') {
                    // 老训练营
                    jumpModuleApp({
                        dataId: item.courseId,
                        typeId: 'operation_detail'
                    });
                }
                else if (/^(NEW_OMO|TEAM)/.test(courseType)) {
                    jumpModuleApp({
                        typeId: 'h5',
                        url: `${hostPath}/learn/courseguide/train/${courseId}`
                    });
                }
                else if (/^PERIOD/.test(courseType)) {
                    jumpModuleApp({
                        typeId: 'h5',
                        url: `${hostPath}/learn/courseguide/meeting/${courseId}`
                    });
                }
                else if ('OPEN' == courseType) {
                    goToStudy('album', courseId);
                }
                else {
                    jumpModuleApp({
                        typeId: 'h5',
                        url: `${hostPath}/learn/courseguide/album/${courseId}`
                    });
                }
            }
            else {
                if (item.courseType == 'OLD_OMO') {
                    // 老训练营
                    location.assign(`${hostPath}/training/detail?id=${courseId}`);
                }
                else if (/^(NEW_OMO|TEAM)/.test(courseType)) {
                    router.push({
                        name: 'courseGuidePage',
                        params: { type: 'train', id: courseId }
                    });
                }
                else if (/^PERIOD/.test(courseType)) {
                    router.push({
                        name: 'courseGuidePage',
                        params: { type: 'meeting', id: courseId }
                    });
                }
                else if ('OPEN' == courseType) {
                    // location.assign(`${hostPath}/open/detail?id=${courseId}`)
                    goToStudy('album', courseId);
                }
                else {
                    router.push({
                        name: 'courseGuidePage',
                        params: { type: 'album', id: courseId }
                    });
                }
            }
        };
        const { isWechat, handleErrorFn, handleLaunchFn, launchReady, btnStyle } = useWxLaunchApp();
        // 是否显示按钮 公开课、练 微信中 Android 设备
        const showLaunch = (item) => {
            if (/(OLD_OMO|OPEN)/.test(item.courseType) && !iOSPort() && isWechat.value) {
                return true;
            }
            return false;
        };
        // 微信
        const extinfo = (item) => {
            let { courseType, courseId } = item;
            if (courseType == 'OLD_OMO') {
                // 老训练营
                return {
                    typeId: 'operation_detail',
                    dataId: courseId
                };
            }
            if (courseType == 'OPEN') {
                // 公开课直接进入学习页
                return {
                    typeId: 'study_play_detail',
                    type: 'album',
                    dataId: courseId
                };
            }
            return {};
        };
        return (_ctx, _cache) => {
            const _component_wx_open_launch_app = _resolveComponent("wx-open-launch-app");
            const _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, key) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: "flex",
                        key: item.courseId,
                        onClick: _withModifiers(($event) => (toDetail(item)), ["stop"])
                    }, [
                        (showLaunch(item))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_component_wx_open_launch_app, {
                                    id: "launch-btn wechatOpenApp",
                                    appid: "wxc48f4cdd885acc63",
                                    onLaunch: _unref(handleLaunchFn),
                                    onError: _unref(handleErrorFn),
                                    onReady: _unref(launchReady),
                                    extinfo: JSON.stringify(extinfo(item))
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "text/wxtag-template" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", {
                                                    class: "btn",
                                                    style: _normalizeStyle(_unref(btnStyle))
                                                }, null, 4)
                                            ]),
                                            _: 1
                                        }))
                                    ]),
                                    _: 2
                                }, 1032, ["onLaunch", "onError", "onReady", "extinfo"])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                                [_directive_lazy, item.cover]
                            ]),
                            (item.courseTypeName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.courseTypeName), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(item.courseName), 1),
                            (item.experts?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    (item.experts)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.experts, (expert) => {
                                            return (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(expert.expertName) + " ", 1));
                                        }), 256))
                                        : _createCommentVNode("", true),
                                    (item.hospitals?.length)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.hospitals, (n) => {
                                            return (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(n.hospitalName), 1));
                                        }), 256))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (!__props.process)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    (/^(OLD_OMO|NEW_OMO|TEAM|PERIOD)/.test(item.courseType))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (item.aal)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "随到随学"))
                                                : (item.startedAt)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                        _createTextVNode(_toDisplayString(item.startedAt + '开营') + " ", 1),
                                                        (item.address)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(' | ' + item.address), 1))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                        ], 64))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createElementVNode("span", null, _toDisplayString(adjustMin(item.length)) + "分钟 ", 1),
                                            (item.publishedAt)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.publishedAt) + "上架", 1))
                                                : _createCommentVNode("", true)
                                        ]))
                                ]))
                                : _createCommentVNode("", true),
                            (!fixedStatus(item) && item.statusName)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["openStatus", { grayColor: item.status !== 'OPENED' || item.remain === 0 }])
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(item.statusName), 1)
                                ], 2))
                                : _createCommentVNode("", true)
                        ])
                    ], 8, _hoisted_2));
                }), 128))
            ]));
        };
    }
});
